module.exports = __webpack_public_path__ + "img/enjoy-transfer-service.8bf43625.svg";